<!--
 * @Descripttion: 数据表格组件
 * @version: 1.10
 * @Author: DH 21:51:15
 * @LastEditors: DH
-->

<template>
    <div class="scTable" :style="{ height: _height }" ref="scTableMain" v-loading="loading">
        <div class="scTable-table" :style="{ height: _table_height }">
            <el-table class="el-table" v-bind="$attrs" :data="data" :row-key="rowKey" ref="scTable" :height="height === 'auto' ? null : '100%'" :size="config.size" :border="config.border" :stripe="config.stripe" :summary-method="remoteSummary ? remoteSummaryMethod : summaryMethod" highlight-current-row @selection-change="handleSelectionChange">
                <slot></slot>
                <sc-table-column v-bind="item" v-for="(item, index) in showColumns" :key="index" :column="item"></sc-table-column>
                <slot name="append"></slot>
                <el-table-column min-width="1"></el-table-column>
                <template #empty>
                    <el-empty :description="emptyText" :image-size="100"></el-empty>
                </template>
            </el-table>
        </div>
        <div class="scTable-page" v-if="pagination?.size > 0 || !hideDo">
            <div class="scTable-pagination">
                <el-pagination v-if="pagination?.size > 0" background :small="true" :layout="pageInfo.layout" :total="pageInfo.total" :page-size="pageInfo.size" :page-sizes="pageInfo.sizes" v-model:currentPage="pageInfo.current" @current-change="paginationChange" @update:page-size="pageSizeChange"></el-pagination>
            </div>
            <div class="scTable-do" v-if="!hideDo">
                <el-button v-if="!hideRefresh" @click="$refs.scTable.clearSelection();$emit('refresh',pageInfo)" icon="el-icon-refresh" circle style="margin-left: 15px"></el-button>
                <el-popover v-if="columns" placement="top" title="列设置" :width="500" trigger="click" :hide-after="0" @show="customColumnShow = true" @after-leave="customColumnShow = false">
                    <template #reference>
                        <el-button icon="el-icon-set-up" circle style="margin-left: 15px"></el-button>
                    </template>
                    <columnSetting v-if="columns" ref="columnSetting" @save-setting="(v)=>$emit('save-setting',v)" :columns="columns"></columnSetting>
                </el-popover>
                <el-popover v-if="!hideSetting" placement="top" title="表格设置" :width="400" trigger="click" :hide-after="0">
                    <template #reference>
                        <el-button icon="el-icon-setting" circle style="margin-left: 15px"></el-button>
                    </template>
                    <el-form label-width="80px" label-position="left">
                        <el-form-item label="表格尺寸">
                            <el-radio-group v-model="config.size" size="small" @change="configSizeChange">
                                <el-radio-button label="large">大</el-radio-button>
                                <el-radio-button label="default">正常</el-radio-button>
                                <el-radio-button label="small">小</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="样式">
                            <el-checkbox v-model="config.border" label="纵向边框"></el-checkbox>
                            <el-checkbox v-model="config.stripe" label="斑马纹"></el-checkbox>
                        </el-form-item>
                    </el-form>
                </el-popover>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, watchEffect, reactive, provide, ref} from 'vue'
import columnSetting from './column-setting'
import ScTableColumn from './columns/tableColumn.vue'


export default {
    name: 'scProTable',
    components: {
        columnSetting,
        ScTableColumn,
    },
    emits: ['pagination-change', 'filter-change', 'save-setting', 'refresh'],
    props: {
        tableName: {type: String, default: ''},
        loading: {type: Boolean, default: false},
        data: {type: Array, default: () => []},
        height: {type: [String, Number], default: '100%'},
        size: {type: String, default: 'small'},
        border: {type: Boolean, default: false},
        stripe: {type: Boolean, default: false},
        rowKey: {type: String, default: 'id'},
        summaryMethod: {type: Function, default: null},
        columns: {type: Array, default: () => []},
        remoteSort: {type: Boolean, default: false},
        remoteFilter: {type: Boolean, default: false},
        remoteSummary: {type: Boolean, default: false},
        hideDo: {type: Boolean, default: false},
        hideRefresh: {type: Boolean, default: false},
        hideSetting: {type: Boolean, default: false},
        pagination: {
            type: Object,
        },
    },
    setup(props, content) {
        const config = reactive({
            size: props.size,
            border: props.border,
            stripe: props.stripe,
        })
        const pageInfo = reactive({
            layout: 'total, sizes, prev, pager, next, jumper',
            total: 0,
            current: 1,
            size: 20,
            sizes: [10, 20, 30, 40, 50],
        })
        provide('proTableContext', {pageInfo: pageInfo})

        watchEffect(() => {
            Object.assign(config, {
                size: props.size,
                border: props.border,
                stripe: props.stripe,
            })
            Object.assign(pageInfo, props.pagination || {size: -1})
        })

        const pageSizeChange = (v) => {
            pageInfo.size = v
            content.emit('pagination-change', pageInfo)
        }
        const paginationChange = (v) => {
            pageInfo.current = v
            content.emit('pagination-change', pageInfo)
        }
        const handleFilterChange = (v) => {
            // console.log('-------------column-filter-change')
            const value = v.value
            const condition = v.filter.condition || ''
            const r = {}
            Array.from(condition.split(',')).forEach((i, index) => {
                r[v.column.property + '_' + i] = Array.isArray(value)
                    ? value[index]
                    : value
            })
            if (v.sort) {
                r.orderBy = v.column.property + (v.sort == 'ASC' ? '+' : '-')
            }
            // console.log('-------------table')
            content.emit('filter-change', r)
        }
        const scTable = ref()
        const handleAction = (action, row) => {
            content.emit('action', {
                action,
                row,
                selected: scTable.value.clearSelection(),
            })
        }
        provide('filterHandler', handleFilterChange)
        provide('actionHandler', handleAction)
        const _height = computed(() =>
            Number(props.height) ? Number(props.height) + 'px' : props.height
        )
        const _table_height = computed(() =>
            props.pagination?.size > 0 || !props.hideDo ? 'calc(100% - 50px)' : '100%'
        )
        const showColumns = computed(() =>
            Array.from(props.columns || []).filter((i) => !i.hide)
        )
		const handleSelectionChange=(e)=>{
			content.emit('selection-change',e)
		}
        return {
            scTable,
            pageInfo,
            pageSizeChange,
            paginationChange,
            config,
            _height,
            _table_height,
            showColumns,
            handleFilterChange,
        }
    },
    data() {
        return {
            scPageSize: this.pageSize,
            emptyText: '暂无数据',
            toggleIndex: 0,
            currentPage: 1,
            prop: null,
            order: null,
            tableHeight: '100%',
            tableParams: this.params,
            userColumn: [],
            customColumnShow: false,
            summary: {},
        }
    },
    methods: {

        configSizeChange() {
            this.$refs.scTable.doLayout()
        },
        //插入行 unshiftRow
        unshiftRow(row) {
            this.data.unshift(row)
        },
        //插入行 pushRow
        pushRow(row) {
            this.data.push(row)
        },
        //根据key覆盖数据
        updateKey(row, rowKey = this.rowKey) {
            this.data
                .filter((item) => item[rowKey] === row[rowKey])
                .forEach((item) => {
                    Object.assign(item, row)
                })
        },
        //根据index覆盖数据
        updateIndex(row, index) {
            Object.assign(this.data[index], row)
        },
        //根据index删除
        removeIndex(index) {
            this.data.splice(index, 1)
        },
        //根据index批量删除
        removeIndexes(indexes = []) {
            indexes.forEach((index) => {
                this.data.splice(index, 1)
            })
        },
        //根据key删除
        removeKey(key, rowKey = this.rowKey) {
            this.data.splice(
                this.data.findIndex((item) => item[rowKey] === key),
                1
            )
        },
        //根据keys批量删除
        removeKeys(keys = [], rowKey = this.rowKey) {
            keys.forEach((key) => {
                this.data.splice(
                    this.data.findIndex((item) => item[rowKey] === key),
                    1
                )
            })
        },
        //原生方法转发
        clearSelection() {
            this.$refs.scTable.clearSelection()
        },
        toggleRowSelection(row, selected) {
            this.$refs.scTable.toggleRowSelection(row, selected)
        },
        toggleAllSelection() {
            this.$refs.scTable.toggleAllSelection()
        },
        toggleRowExpansion(row, expanded) {
            this.$refs.scTable.toggleRowExpansion(row, expanded)
        },
        setCurrentRow(row) {
            this.$refs.scTable.setCurrentRow(row)
        },
        clearSort() {
            this.$refs.scTable.clearSort()
        },
        clearFilter(columnKey) {
            this.$refs.scTable.clearFilter(columnKey)
        },
        doLayout() {
            this.$refs.scTable.doLayout()
        },
        sort(prop, order) {
            this.$refs.scTable.sort(prop, order)
        },
    },
}
</script>

<style scoped>
.scTable {
}

.scTable-table {
    height: calc(100% - 50px);
}

.scTable-page {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

.scTable-do {
    white-space: nowrap;
}

.scTable:deep(.el-table__footer) .cell {
    font-weight: bold;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-horizontal {
    height: 6px;
    border-radius: 12px;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-vertical {
    width: 12px;
    border-radius: 12px;
}
</style>
